<template>
  <div>
    <div v-if="baseline">
      <div>
        <h3>{{ baseline.name }}</h3>
      </div>
      <delete-baseline-modal :baseline="baseline" modalId="delete-baseline-modal"></delete-baseline-modal>
      <div class="detail-view-buttons">
        <b-button variant="danger" size="sm" v-b-modal.delete-baseline-modal>
          Delete
        </b-button>
      </div>
      <div class="card mt-2">
        <div class="card-body">
          <h4 class="card-title">Details</h4>
          <div class="card-text">
            <table class="table table-sm baseline-detail-table">
              <tbody>
              <tr>
                <th scope="row">ID:</th>
                <td>B{{ baseline.baseline_id }}</td>
              </tr>
              <tr>
                <th scope="row">Created:</th>
                <td>{{ getHumanDate(baseline.created_at + 'Z') }}</td>
              </tr>
              <tr>
                <th scope="row">Reporter:</th>
                <td v-if="reporter">{{ reporter.displayName }}</td>
                <td class="help-text" v-else>None</td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="card mt-2">
        <div class="card-body">
          <h4 class="card-title">Description</h4>
          <div class="card-text">
            <b-form-textarea v-if="baseline.description"
                             plaintext
                             no-resize
                             :max-rows="6"
                             :value="baseline.description">
            </b-form-textarea>
            <span class="help-text" v-else>No description</span>
          </div>
        </div>
      </div>
      <div class="card mt-2">
        <div class="card-body">
          <h4 class="card-title">Requirements</h4>
          <div class="card-text">
            <table class="table table-sm baseline-detail-table" v-if="baseline.requirement_revisions.length > 0">
              <thead>
              <tr>
                <th scope="col">ID</th>
                <th scope="col">Name</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="requirement_revision in baseline.requirement_revisions">
                <th scope="row">{{ requirement_revision.prefix }}{{ requirement_revision.display_id ? requirement_revision.display_id : requirement_revision.requirement_id }}</th>
                <td>{{ requirement_revision.name }}</td>
              </tr>
              </tbody>
            </table>
            <span class="help-text" v-else>No requirements in baseline</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else-if="loading">
      <div class="d-flex justify-content-center align-items-center">
        <icon  name="spinner" pulse scale="5"></icon>
      </div>
    </div>
  </div>
</template>


<script>
  import DeleteBaselineModal from '@/components/modals/DeleteBaselineModal'
  import utilsMixin from '@/mixins/utils'
  import dayjs from 'dayjs'
  import advancedFormat from 'dayjs/plugin/advancedFormat'
  dayjs.extend(advancedFormat)
  export default {
    components: { DeleteBaselineModal },
    data () {
      return {
        baseline: null,
        loading: false,
        reporter: null
      }
    },
    computed: {
      currentBaseline () {
        return this.$store.state.currentBaseline
      },
      currentProject () {
        return this.$store.state.currentProject
      }
    },
    mounted () {
      this.refreshData()
    },
    watch: {
      currentBaseline (currentValue) {
        this.refreshData()
      }
    },
    mixins: [utilsMixin],
    methods: {
      getBaseline () {
        this.$http.get(
          `/api/baseline/${this.baselineProp.baseline_id}/lite?atlassian_project_id=${this.currentProject.id}`
        ).then(response => {
          this.baseline = response.data.baseline
          this.loading = false
          this.getReporterDataFromAtlassian()
        }, response => {
          console.log('error')
          this.loading = false
        })
      },
      getHumanDate (date) {
        return dayjs(date).format('MMMM Do YYYY, h:mm:ss a')
      },
      getReporterDataFromAtlassian () {
        // TODO - factor out this user call and the one above.  had trouble assigning the result to a variable blah
        if (this.baseline.created_by) {
          window.AP.request({
            url: `/rest/api/3/user?accountId=${this.baseline.created_by.account_id}`,
            success: response => {
              // convert the string response to JSON
              response = JSON.parse(response)
              this.reporter = response
            },
            error: () => {
              console.log(arguments)
            }
          })
        } else {
          this.reporter = null
        }
      },
      refreshData () {
        this.baseline = null
        this.loading = true
        this.getBaseline()
      }
    },
    props: {
      baselineProp: Object
    }
  }
</script>

<style>
  .card-body .card-text .baseline-detail-table {
    margin-bottom: 0;
  }
</style>



// WEBPACK FOOTER //
// BaselineDetail.vue?f6c35560